import React from 'react';

import { VpHookFormInput } from '../../inputs';

export const PhoneNumberInput = () => {
  const rules = {
    minLength: {
      value: 8,
      message: 'Phone number must be at least 8 characters long'
    }
  };
  return (
    <VpHookFormInput
      isNumber
      maxLength={20}
      rules={rules}
      required
      name="phoneNumber"
      placeholder="Phone Number"
    />
  );
};

export default PhoneNumberInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/sign-up/PhoneNumberInput.jsx